import { createContext, useCallback, useState } from "react";
import PropTypes from "prop-types";

const SCHOOL_AUTH_STORAGE_KEY = "school-portal-user";

const getStoredSchoolUser = () => {
  try {
    const storedSchoolUser = localStorage.getItem(SCHOOL_AUTH_STORAGE_KEY);
    return storedSchoolUser ? JSON.parse(storedSchoolUser) : null;
  } catch {
    localStorage.removeItem(SCHOOL_AUTH_STORAGE_KEY);
    return null;
  }
};

const SchoolAuthContext = createContext();

export const SchoolAuthProvider = ({ children }) => {
  const [schoolUser, setSchoolUser] = useState(getStoredSchoolUser);

  const loginSchool = useCallback((token, userInfo, school, dashboard) => {
    const userData = {
      token,
      role: "SchoolPortal",
      userInfo,
      school,
      dashboard,
    };

    localStorage.setItem(SCHOOL_AUTH_STORAGE_KEY, JSON.stringify(userData));
    setSchoolUser(userData);
  }, []);

  const logoutSchool = useCallback(() => {
    localStorage.removeItem(SCHOOL_AUTH_STORAGE_KEY);
    setSchoolUser(null);
  }, []);

  const updateSchoolProfile = useCallback((profile) => {
    if (!profile || typeof profile !== "object") return;

    setSchoolUser((currentUser) => {
      if (!currentUser) return currentUser;

      const updatedUser = {
        ...currentUser,
        school: {
          ...currentUser.school,
          ...profile,
        },
      };

      localStorage.setItem(SCHOOL_AUTH_STORAGE_KEY, JSON.stringify(updatedUser));
      return updatedUser;
    });
  }, []);

  return (
    <SchoolAuthContext.Provider
      value={{
        schoolUser,
        loginSchool,
        logoutSchool,
        updateSchoolProfile,
      }}
    >
      {children}
    </SchoolAuthContext.Provider>
  );
};

SchoolAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SchoolAuthContext;
